import MerchandiseProductLevel from 'merchandise-lib/constants/ProductLevel';
export const ProductLevel = MerchandiseProductLevel;
export const orderedProductLevels = [ProductLevel.FREE, ProductLevel.STARTER, ProductLevel.PROFESSIONAL, ProductLevel.ENTERPRISE];
export const currentOrderedProductLevels = orderedProductLevels;
export const currentOrderedPaidProductLevels = [ProductLevel.STARTER, ProductLevel.PROFESSIONAL, ProductLevel.ENTERPRISE];